import { getBackend } from '@/backend';
import type { ActionItemsManagementSnapshot } from '@/backend/contracts/action-items-client';

import type { ProjectScope } from './project-scope';

function actionItemsClient() {
    const client = getBackend().actionItems;
    if (!client) throw new Error('Action Items backend client is not configured');
    return client;
}

/** Subscribe to the canonical, coherent Action Items management read model. */
export function subscribeToActionItemsManagement(
    scope: ProjectScope,
    access: 'view' | 'edit',
    onUpdate: (snapshot: ActionItemsManagementSnapshot) => void,
    onError?: (error: Error) => void,
) {
    return actionItemsClient().subscribeManagement(scope, { access }, onUpdate, onError);
}

export {
    createActionItemWriteOperation,
    createManualActionItem,
    dismissActionItemDraft,
    patchActionItem,
    promoteActionItemDraft,
} from './action-item-write-operations';
